'use strict';

function AuthLogin($http, $window, languageService) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.login = _login;
  vm._refreshLanguages = _refreshLanguages;
  vm.changeLanguage = changeLanguage;

  function $onInit() {
    $window.location.href = '/login';
    // vm._refreshLanguages();
  }

  function _login() {
    return $http.post('/login/', {'email': vm.email, 'password': vm.password}, {}).then(_success, _failed);
  }

  function _success() {
    vm.failedLogin = false;
    $window.location.href = '/';
  }

  function _failed() {
    vm.failedLogin = true;
  }

  function _refreshLanguages() {
    return languageService.list()
      .then(function (response) {
        vm.languages = response;
      });
  }

  function changeLanguage(language) {
    return languageService.update(language)
      .then(vm._refreshLanguages).then(function () {
        $window.location.reload();
      });
  }

}

module.exports = AuthLogin;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/auth-login/auth-login.controller.js
 ** module id = 173
 ** module chunks = 0
 **/